//STYLES
import styles from "./Navbar.module.scss";
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
//CONTEXT
import { useContext } from "react";
import NavContext from "../../Context/NavContext";

//REACT ROUTER
import { NavLink } from "react-router-dom";
//ICONS
import { FaTimes } from "react-icons/fa";
import {  FaFileAlt} from "react-icons/fa"
import {  FaUserTie} from "react-icons/fa"
import {  FaMapMarkerAlt} from "react-icons/fa"
import {  FaMarker} from "react-icons/fa"
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import VerifiedIcon from '@mui/icons-material/Verified';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';

import verified from "../../assets/check-mark.png"
import pending from "../../assets/pencil.png"
import PendingIcon from '@mui/icons-material/Pending';
import Pen from "../../pics/pen.svg";
//import Stox from "../../pics/stoxkart.svg";
import Stox from '../../pics/stoxkart_old_logo.png'


const NavUrl = ({ url, icon, description, }) => {
  const { nav, setNav } = useContext(NavContext);
  const checkWindowSize = () => {
    if (window.innerWidth < 1024) setNav(!nav);
  };

  return (
    <li className={styles.li_navlink}>
      <NavLink
        to={`${url}`}
        className={({ isActive }) => (isActive ? styles.active : undefined)}
        onClick={() => checkWindowSize()}
      >
        {icon}
        <span className={styles.description}>{description}</span>
      </NavLink>
    </li>
  );
};

const Navbar = ({msg}) => {
  const { nav, setNav } = useContext(NavContext);

  return (
    <div
      className={`${styles.navbar_container} ${
        nav ? styles.navbar_mobile_active : undefined
      }`}
    >
      <nav className={nav ? undefined :  undefined }>
        <div className={styles.logo}>
          <img src={Stox} alt="logo" className={styles.logo_icon} style={{ width: '85%'}}/>
          {/* <FaTimes
            className={styles.mobile_cancel_icon}
            onClick={() => {
              setNav(!nav);
            }}
          /> */}
        </div>

        {/* MENU */}
        <ul className={styles.menu_container}>
          {/* FIRST CATEGORY */}

          <NavUrl
            url="/main"
            icon={
            <>
            <FaUserTie />

            <span style={{margin: '0px 10px 0px 10px'}}>Personal Details</span> 
            {(() => {
        if (msg.personalDetailStatus == 'VERIFIED') {
          return (
            // <img src={verified} alt="ver" className="verified_icon" />
            <VerifiedIcon className="verified_icon"/>
          )
        } else if (msg.personalDetailStatus == 'REJECTED') {
          return (
            // <i className="pi pi-times-circle reject_icon" />
            <CancelIcon className="reject_icon"/>

          )
        } 
        else if (msg.personalDetailStatus == 'IN-PROCESS') {
          return (
            // <PendingIcon className="inprocess_icon"/>
            // <PendingActionsIcon className="inprocess_icon"/>
            // <WatchLaterRoundedIcon className="inprocess_icon"/>
            <img src={pending} alt="inp" className="inprocess_icon"/>



            // <img src={inProcess} alt="inp" className="inprocess_icon"/>
          )
        } else if (msg.personalDetailStatus == "PENDING") {
          return (
            <HourglassTopRoundedIcon className="pending_icon"/>
            // <HourglassTopIcon className="pending_icon"/>
          )
        }
        else {
          return null
        }
      })()}
            </>}
    
        
    
          >
           
            </NavUrl>
          <NavUrl
            url="/permanent"
            icon={<>
            <FaMapMarkerAlt />
            <span style={{margin: '0px 10px 0px 10px'}}>Address</span>
            {(() => {
        if (msg.addressDetailStatus == 'VERIFIED') {
          return (
            // <img src={verified} alt="ver" className="verified_icon" />
            <VerifiedIcon className="verified_icon"/>
          )
        } else if (msg.addressDetailStatus == 'REJECTED') {
          return (
            // <i className="pi pi-times-circle reject_icon" />
            <CancelIcon className="reject_icon"/>

          )
        } 
        else if (msg.addressDetailStatus == 'IN-PROCESS') {
          return (
            <img src={pending} alt="inp" className="inprocess_icon"/>
            // <PendingIcon className="inprocess_icon"/>
            // <PendingActionsIcon className="inprocess_icon"/>
            // <WatchLaterRoundedIcon className="inprocess_icon"/>

          )
        } else if (msg.addressDetailStatus == "PENDING") {
          return (
            // <HourglassTopIcon className="pending_icon"/>
            <HourglassTopRoundedIcon className="pending_icon"/>
          )
        } 
        else {
          return null
        }
      })()} 
            </>}/>

          <NavUrl
            url="/segment"
            icon={<>
            <FaFileAlt />
            
            <span style={{margin: '0px 8px'}}>Segment Details </span>
            
            {(() => {
        if (msg.segmentDetailStatus == 'VERIFIED') {
          return (
            // <img src={pending} alt="ver" className="verified_icon" />
            // <VerifiedIcon className="verified_icon"/>
            <VerifiedIcon className="verified_icon"/>
            

          )
        } else if (msg.segmentDetailStatus == 'REJECTED') {
          return (
            // <i className="pi pi-times-circle reject_icon" />
            <CancelIcon className="reject_icon"/>

          )
        } 
        else if (msg.segmentDetailStatus == 'IN-PROCESS' ) {
          return (
            <img src={pending} alt="inp" className="inprocess_icon"/>
            // <PendingIcon className="inprocess_icon"/>
            // <PendingActionsIcon className="inprocess_icon"/>
            // <WatchLaterRoundedIcon className="inprocess_icon"/>

          )
        } else if (msg.segmentDetailStatus == "PENDING") {
          return (
            <HourglassTopRoundedIcon className="pending_icon"/>
            // <HourglassTopIcon className="pending_icon"/>
          )
        }
        else {
          return null
        }
      })()} 
            </>}/>

          <NavUrl
            url="/esign"
            icon={<>
            <FaMarker />

            <span style={{margin: '0px 10px 0px 10px'}}>Esign</span> 
            {(() => {
        if (msg.esignDetailStatus == 'VERIFIED') {
          return (
            // <img src={verified} alt="ver" className="verified_icon" />
            <VerifiedIcon className="verified_icon"/>
          )
        } else if (msg.esignDetailStatus == 'REJECTED') {
          return (
            // <i className="pi pi-times-circle reject_icon" />
            <CancelIcon className="reject_icon"/>
          )
        } 
        else if (msg.esignDetailStatus == 'IN-PROCESS') {
          return (
            <img src={pending} alt="inp" className="inprocess_icon"/>
            // <PendingIcon className="inprocess_icon"/>
            // <CancelOutlinedIcon className="inprocess_icon"/>
            // <WatchLaterRoundedIcon className="inprocess_icon"/>



          )
        } else if (msg.esignDetailStatus == "PENDING") {
          return (
            <HourglassTopRoundedIcon className="pending_icon"/>
            // <HourglassTopIcon className="pending_icon"/>
          )
        }
        else {
          return null
        }
      })()}
            
            </>}/>
        </ul>

        <div className={styles.copyright}>
          {
            msg.esignDetailStatus == 'REJECTED' ? <div className="top_msg_red">Your re-KYC application was rejected. Please provide details/documents as per remarks.</div> : msg.esignDetailStatus == 'VERIFIED' ? <div className="top_msg_green">Your re-KYC verification was successful. Happy Trading! </div> : msg.esignDetailStatus == "PENDING" ? <div className="top_msg_yellow">Your request for Re-activation is under process and It will be updated within 2 working days after successful acceptance of request.</div> : null
          }
{/* <h6>© 2021 Stoxkart</h6>
<p>Lorem ipsum dolor sit amet, consectetur
adipiscing elit ut aliquam, purus sit amet</p> */}
        </div>

      </nav>
      <div
        className={nav ? styles.mobile_nav_background_active : undefined}
        onClick={() => {
          setNav(!nav);
        }}
      ></div>
    </div>
  );
};

export default Navbar;
